import React from "react";
import classNames from 'classnames';  
import {checkStoreClerk} from '../../redux/actions/loginAction';

import {connect} from 'react-redux';   

class LoginPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            username: "",
            password: "",
            storeId: window.sessionStorage.getItem('storeId'), 
            errorMsg: ""  
         }
        this.handleChange = this.handleChange.bind(this); 
        this.storeClerkAuth = this.storeClerkAuth.bind(this); 
    }  

    handleChange(e) { 
        let { name, value } = e.target;
        this.setState({ [name]: value });
    } 
    
     //update the state value once clicked the Find Order button
     componentWillReceiveProps(nextProps){
        this.setState({
            errorMsg: nextProps.loginResult.errorMessage, 
            username: nextProps.username,
            password: nextProps.password 
        });      
    }

    // Check Store Clerk Login credentials
    storeClerkAuth(e){
        e.preventDefault();
        this.setState({
            errorMsg: ''
        });           
        let loginInputData= {"username":this.state.username.trim(),"password" : this.state.password.trim(),
                           "storeId":this.state.storeId}; 
        this.props.checkStoreClerk(loginInputData,this.props);  
    }

    render() {

        let inputClasses = classNames({
            'form-control' : true,'input-ctrl': true,'is-invalid':this.state.errorMsg?true:false
         });

    return ( 

        <div className="row justify-content-center">
            <div className="col-6">
                <div className="form-sections1">

                    <div className="login-title">
                        IN STORE RETURN PORTAL
                    </div>
                    <form name='form' onSubmit={this.storeClerkAuth}>
                    <div className="form-group">
                        <label className="required">Store Log In</label>
                        <input type="text" className={inputClasses} name="username" value={this.state.username}  onChange={this.handleChange} required  />
                    </div>

                    <div className="form-group">
                        <label className="required" >Password</label>
                        <input type="password" className={inputClasses} name="password" value={this.state.password}  onChange={this.handleChange} required  />
                    </div> 
                    {this.state.errorMsg &&
                        <div id="error" className="float-right error">  
                            {this.state.errorMsg}                           
                        </div>
                    }
                      <br></br>

                    <div className="row">
                        <div className="col-sm-6">
                            <div className="float-left">
                                <br></br>
                                {/* <button type="button" className="btn btn-primary btn-forgot">Forgot Password</button> */}
                            </div>
                        </div>
                        <div className="col-sm-6">
                            <div className="float-right">
                                <br></br>
                                <button type="submit" className="btn btn-primary btn-new">Login</button>
                            </div>
                        </div>
                    </div>
                    </form >
                </div>

            </div>
        </div> 
        );
    }
}
  
  
  const mapStateToProps = (state) =>({ 
    username: state.login.username,
    password: state.login.password, 
    loginResult: state.login
  });
  
  export default connect(mapStateToProps,{checkStoreClerk})(LoginPage);
  




// WEBPACK FOOTER //
// ./src/components/Login/LoginPage.js